module.exports = __webpack_public_path__ + "static/media/simulator_en.dc70e1ad.png";